import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
interface AppData {
  isInternal: boolean;
  app: any;
}
@Component({
  standalone: false,
  selector: 'app-apps-dialog',
  templateUrl: './apps-dialog.component.html',
  styleUrls: ['./apps-dialog.component.scss']
})
export class AppsDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: AppData) {}

  ngOnInit() {}

  isInternalUpdate(event) {
    this.data.isInternal = event;
  }
}
